export default __webpack_public_path__ + "static/media/foiegras.09573d63.jpg";